import React from "react";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/constants/testIds";

const services = [
  {
    code: "01",
    title: "Enerji & Elektrik Çözümleri",
    subtitle: "Düşük Gerilim & Elektrik Tesisatı",
    desc: "Düşük gerilim elektrik altyapısı, iç tesisat, aydınlatma, güç dağılımı ve pano kurulumları.",
    bullets: [
      "AG Elektrik Altyapı",
      "İç Tesisat & Aydınlatma",
      "Pano Üretim & Montaj",
      "Bakım & Onarım",
    ],
    img: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&q=85&auto=format&fit=crop",
  },
  {
    code: "02",
    title: "Yenilenebilir Enerji (GES)",
    subtitle: "Güneş Enerjisi Sistemleri",
    desc: "Konut ve ticari çatı üstü GES projeleri, DC solar sistem tasarımı, fizibilite ve bakım hizmetleri.",
    bullets: [
      "Çatı Üstü GES",
      "DC Solar Sistem",
      "Konut & Ticari",
      "O&M Hizmetleri",
    ],
    img: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&q=85&auto=format&fit=crop",
  },
  {
    code: "03",
    title: "Mimari, Restorasyon & Modüler Yapılar",
    subtitle: "Villa · Tarihi Restorasyon · Modüler",
    desc: "Villa tasarım ve uygulama, tarihi yapı restorasyonu, modüler yapı konseptleri ve estetik mimari projelendirme.",
    bullets: [
      "Villa Projeleri",
      "Tarihi Restorasyon",
      "Modüler Yapılar",
      "İç Mekan Tasarımı",
    ],
    img: "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=1200&q=85&auto=format&fit=crop",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 border-b border-neutral-900 bg-[#0a0a0b] relative">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-14 max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-6 h-px bg-[#ff5a00]" />
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#ff5a00]">
              Hizmetlerimiz / 03
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
            Uzmanlık <span className="italic font-light text-neutral-400">alanlarımız</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-neutral-900">
          {services.map((s, i) => (
            <article
              key={i}
              data-testid={SITE.serviceCard(i)}
              className="bg-[#0a0a0b] border border-neutral-900 group relative overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-all duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b] via-[#0a0a0b]/40 to-transparent" />
                <div className="absolute top-4 left-4 font-mono-tech text-[10px] tracking-[0.3em] text-[#ff5a00]">
                  {s.code}
                </div>
              </div>

              <div className="p-8 flex-1 flex flex-col">
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
                  {s.subtitle}
                </div>
                <h3 className="font-display text-2xl md:text-[28px] font-semibold text-white tracking-tight mb-4">
                  {s.title}
                </h3>
                <p className="text-sm text-neutral-400 leading-relaxed mb-6">
                  {s.desc}
                </p>
                <ul className="mt-auto grid grid-cols-2 gap-y-2 gap-x-4 pt-6 border-t border-neutral-900">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-center gap-2 text-[13px] text-neutral-300"
                    >
                      <span className="w-1 h-1 bg-[#ff5a00]" />
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-neutral-300 hover:text-[#ff5a00] transition-colors"
                >
                  Detaylı Bilgi <ArrowRight size={14} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
